module.exports = __webpack_public_path__ + "static/media/logo_text.0613f12a.png";